var React = require('react');

function IcWindowsActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#04ACEF","fillRule":"evenodd","d":"M1 14.667v-8.4l9.333-2v10.4H1zm0 2.667h9.333v10.933L1 26.533v-9.199zM30.333 0v14.667H13V3.733L30.333 0zm0 17.333V32L13 28.8V17.333h17.333z"}));
}

IcWindowsActive.defaultProps = {"id":"ic-windows-active","viewBox":"0 0 32 32"};

module.exports = IcWindowsActive;

IcWindowsActive.default = IcWindowsActive;
